/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, OnDestroy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FileDataStore } from '../../../store/file-data.store';
import { FileDataTableRow } from '../../sub-components/file-upload/file-upload-table/file-upload-table.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-view-icon-renderer',
    imports: [
        MatIcon,
        MatTooltipModule,
    ],
    providers: [],
    templateUrl: './view-icon-renderer.component.html',
    styleUrl: './view-icon-renderer.component.scss'
})
export class ViewIconRendererComponent implements ICellRendererAngularComp, OnDestroy {
  isDisabled: boolean = false;
  readonly fileDataStore = inject(FileDataStore);
  private params?: ICellRendererParams<any, any>;
  private subs: Subscription[] = [];

  constructor() {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.isDisabled = 
      params.data?.status?.toLowerCase() != 'success' &&
      params.data?.status?.toLowerCase() != 'failed';
  }

  refresh(params: ICellRendererParams<any, any>) {
    this.params = params;
    return true;
  }

  onClick() {
    const data = this.params?.data as FileDataTableRow | undefined;
    if (!data) { return; }
    this.fileDataStore.onOpenDialog(data);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
